export default __webpack_public_path__ + "76c10295853c27f6ed4dbb2c95801603.png";